// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".coupon-badge[data-v-4ac819dc]{background-color:#777;border-radius:12px;color:#fff;display:inline-flex;align-items:center;min-height:24px;padding:0 .5em 0 .7em}.coupon-badge__close[data-v-4ac819dc]{background:none;font-size:24px;height:24px;line-height:24px;padding:0;margin-left:8px}", ""]);
// Exports
module.exports = exports;
